import { Box, Typography } from "@mui/material";
import { formatWeekdayTime } from "./functions";
import { sharedStyles } from "@/styles/shared";
import { WEEKDAY_LABELS } from "@/pages/Comercial/workingTimeConstants";

interface TimeRangeInterpreterProps {
  timeMonday: string[];
  timeTuesday: string[];
  timeWednesday: string[];
  timeThursday: string[];
  timeFriday: string[];
  timeSaturday: string[];
  timeSunday: string[];
}

const TimeRangeInterpreter = (props: TimeRangeInterpreterProps) => {
  const {
    timeMonday,
    timeTuesday,
    timeWednesday,
    timeThursday,
    timeFriday,
    timeSaturday,
    timeSunday,
  } = props;

  const weekdayTimes = [
    timeMonday,
    timeTuesday,
    timeWednesday,
    timeThursday,
    timeFriday,
    timeSaturday,
    timeSunday,
  ];

  const formattedWeekdayTimes = weekdayTimes.map(formatWeekdayTime);

  return (
    <Box
      sx={{
        ...sharedStyles.horizontalContent,
        alignItems: { xs: "column", md: "row", lg: "row" },
        justifyContent: "space-between",
        flexDirection: { xs: "column", md: "row", lg: "row" },
      }}
    >
      {formattedWeekdayTimes.map((day, index) => (
        <Box
          sx={{ ...sharedStyles.verticalContent, alignItems: "center" }}
          key={index}
        >
          <Typography variant="h6">{WEEKDAY_LABELS[index]}</Typography>

          <Box
            sx={{
              ...sharedStyles.verticalContent,
              gap: 0,
            }}
          >
            {day.length > 0 ? (
              day.map((time, index) => (
                <Typography key={index}>{time}</Typography>
              ))
            ) : (
              <Typography>Não disponível</Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default TimeRangeInterpreter;
